import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemUserDTO } from './SystemUserDTO';
import { UserRoleAssignmentDTO } from './UserRoleAssignmentDTO';
import { environment } from '../../../environments/environment';
import {AbstractService} from "../../services/AbstractService";
import {PageableResponse} from "../Organisation/PageableResponse";
import {OrganisationDTO} from "../Organisation/OrganisationDTO";

@Injectable({
  providedIn: 'root'
})
export class SystemUserService extends AbstractService<any> {
  protected constructor(protected override http: HttpClient) {
    super(http);
  }
  override getApiURL() {
    return "system-users";
  }

  filterSystemUsers(params: any, filterData: any = {}): Observable<PageableResponse<SystemUserDTO>> {
    return this.http.post<any>(`${environment.apiUrl}${this.getApiURL()}/filter`, filterData, { params });
  }

  getSystemUserById(id: number): Observable<SystemUserDTO> {
    return this.http.get<SystemUserDTO>(`${environment.apiUrl}${this.getApiURL()}/${id}`);
  }

  getUnregisteredKeycloakUsers(params: any, filter: any): Observable<PageableResponse<SystemUserDTO>> {
    return this.http.post<PageableResponse<SystemUserDTO>>(`${environment.apiUrl}${this.getApiURL()}/unregistered-keycloak-users`, filter, { params });
  }

  createFromKeycloak(users: SystemUserDTO[]): Observable<SystemUserDTO[]> {
    const headers = { 'X-Skip-Interceptor-Error': 'true' };
    return this.http.post<SystemUserDTO[]>(`${environment.apiUrl}${this.getApiURL()}/create-from-keycloak`, users, { headers });
  }

  deleteSystemUser(id: number): Observable<any> {
    const headers = { 'X-Skip-Interceptor-Error': 'true' };
    return this.http.delete(`${environment.apiUrl}${this.getApiURL()}/${id}`, { headers });
  }

  toggleUserStatus(id: number): Observable<SystemUserDTO> {
    const headers = { 'X-Skip-Interceptor-Error': 'true' };
    return this.http.put<SystemUserDTO>(`${environment.apiUrl}${this.getApiURL()}/${id}/active-status`, {}, { headers });
  }

  assignRolesToUser(roleAssignmentDTO: UserRoleAssignmentDTO): Observable<any> {
    const headers = { 'X-Skip-Interceptor-Error': 'true' };
    return this.http.post<any>(`${environment.apiUrl}${this.getApiURL()}/assign-roles`, roleAssignmentDTO, { headers });
  }

  getKeycloakUserRoles(userId: string): Observable<any> {
    const headers = { 'X-Skip-Interceptor-Error': 'true' };
    return this.http.get<any>(`${environment.apiUrl}${this.getApiURL()}/${userId}/keycloak-roles`, { headers });
  }

  removeRolesFromUser(roleAssignmentDTO: UserRoleAssignmentDTO): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}${this.getApiURL()}/remove-roles`, roleAssignmentDTO);
  }
}
